<template>
  <div v-cloak @drop.prevent="addDropFile" @dragover.prevent>
    <v-file-input :label="label" v-model="files" :error-messages="errors" :prepend-icon="null" chips multiple>
      <template v-slot:append>
        <v-icon small class="pa-0 ma-0">{{ icon }}</v-icon>
        <v-btn
          icon
          small
          :disabled="uploading"
          :loading="uploading"
          @click="uploadToBackend"
          class="pa-0 ma-0"
          v-if="!upload"
        >
          <v-icon small>{{ $vuetify.icons.values.addCircleInverted }}</v-icon>
        </v-btn>
      </template>
    </v-file-input>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { CustomFieldMixin } from '../mixins'
import { NAMESPACE } from '../store'

export default {
  name: 'FileUploadField',
  mixins: [CustomFieldMixin],
  props: {
    icon: { type: String },
    prefix: { type: String },
    upload: { type: Boolean, default: false }
  },
  data: () => ({
    uploading: false,
    files: []
  }),
  watch: {
    files: function (v) {
      if (v && this.upload) {
        this.uploadToBackend()
      }
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['addFiles']),
    uploadToBackend() {
      this.uploading = true
      let datas = this.files.map((x) => {
        let f = new FormData()
        f.append('file', x)
        if (this.prefix) {
          f.append('prefix', this.prefix)
        }
        return f
      })
      this.addFiles(datas).then((files) => {
        this.setValue(files)
        this.uploading = false
      })
    },
    addDropFile(e) {
      this.files = Array.from(e.dataTransfer.files)
    }
  }
}
</script>
